import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Slider, Box, Button } from '@material-ui/core';
import MyLocationIcon from '@material-ui/icons/MyLocation';
import OpenWithIcon from '@material-ui/icons/OpenWith';

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 12,
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  title: {
    fontSize: 14,
    fontWeight: 500,
  },
  value: {
    fontSize: 14,
    fontWeight: 500,
    color: '#1565c0',
  },
  slider: {
    color: '#1565c0',
  },
  range: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 4,
    fontSize: 11,
    color: '#999',
  },
  hint: {
    fontSize: 11,
    color: '#999',
    marginTop: 8,
    display: 'block',
  },
  repositionRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginTop: 12,
  },
  repositionBtn: {
    textTransform: 'none',
    fontSize: 12,
    padding: '4px 10px',
  },
  customChip: {
    fontSize: 10,
    padding: '2px 6px',
    background: '#EEF2FF',
    color: '#4F46E5',
    borderRadius: 4,
    marginLeft: 6,
  },
}));

const GeofenceSection = ({
  radius,
  onRadiusChange,
  onRadiusCommit,
  disabled,
  repositioning,
  hasCustomCenter,
  onStartReposition,
  onConfirmReposition,
  onCancelReposition,
  onResetCenter,
}) => {
  const classes = useStyles();
  const radiusFt = Math.round((radius || 200) * 3.28084);

  return (
    <Box>
      <div className={classes.header}>
        <div className={classes.left}>
          <MyLocationIcon style={{ fontSize: 18, color: '#666' }} />
          <Typography className={classes.title}>Geofence radius</Typography>
          {hasCustomCenter && <span className={classes.customChip}>Repositioned</span>}
        </div>
        <span className={classes.value}>{radiusFt} ft</span>
      </div>
      <Slider
        value={radius || 200}
        onChange={(e, val) => onRadiusChange(val)}
        onChangeCommitted={(e, val) => onRadiusCommit(val)}
        min={15}
        max={1500}
        step={5}
        className={classes.slider}
        disabled={disabled || repositioning}
        valueLabelDisplay="auto"
        valueLabelFormat={(val) => `${Math.round(val * 3.28084)}ft`}
      />
      <div className={classes.range}>
        <span>{Math.round(15 * 3.28084)} ft</span>
        <span>{Math.round(1500 * 3.28084)} ft</span>
      </div>

      {/* Reposition controls */}
      <div className={classes.repositionRow}>
        {!repositioning ? (
          <>
            <Button
              size="small"
              variant="outlined"
              startIcon={<OpenWithIcon style={{ fontSize: 14 }} />}
              className={classes.repositionBtn}
              onClick={onStartReposition}
              disabled={disabled}
            >
              Reposition center
            </Button>
            {hasCustomCenter && (
              <Button
                size="small"
                className={classes.repositionBtn}
                onClick={onResetCenter}
                disabled={disabled}
                style={{ color: '#999' }}
              >
                Reset
              </Button>
            )}
          </>
        ) : (
          <>
            <Button
              size="small"
              variant="contained"
              color="primary"
              className={classes.repositionBtn}
              onClick={onConfirmReposition}
              style={{ background: '#1565c0' }}
            >
              Confirm
            </Button>
            <Button
              size="small"
              variant="outlined"
              className={classes.repositionBtn}
              onClick={onCancelReposition}
            >
              Cancel
            </Button>
          </>
        )}
      </div>

      <Typography className={classes.hint}>
        {repositioning
          ? 'Drag the blue dot on the map to move the geofence center.'
          : 'Drag slider to adjust radius — auto-saves on release.'}
      </Typography>
    </Box>
  );
};

export default GeofenceSection;
